module.exports = __webpack_public_path__ + "media/images/landing/browser_mobile.en-d3e2dd4ecd2bdd9172ed69561978d377.png";